module.exports = __webpack_public_path__ + "static/patrik-blk-37870566e2677ce73a11d4321544516b.jpeg";